// Sambungan terus ke printer thermal BLE melalui Web Bluetooth (Chrome Android). Dua slot: kaunter & dapur.
const SERVICES = [
  0x18f0, 0xff00, 0xffe0, 0xfee7, 0xae30, 0xff12,
  "49535343-fe7d-4ae5-8fa9-9fafd205e455",
  "e7810a71-73ae-499d-8c15-faa9aef0c3f2",
  "0000ae30-0000-1000-8000-00805f9b34fb",
];

export const bleSupported = () => typeof navigator !== "undefined" && !!navigator.bluetooth;

async function findChar(server) {
  for (const s of await server.getPrimaryServices()) {
    for (const c of await s.getCharacteristics()) {
      if (c.properties.write || c.properties.writeWithoutResponse) return c;
    }
  }
  throw new Error("Printer tiada saluran tulis. Pastikan printer menyokong BLE.");
}

function createBle(key) {
  let device = null;
  let ch = null;
  const listeners = new Set();
  const status = () => ({ name: device?.name || "", id: device?.id || "", connected: !!(device?.gatt?.connected && ch) });
  const emit = () => listeners.forEach((f) => f(status()));
  const onDrop = () => { ch = null; emit(); };

  async function attach(d) {
    device = d;
    d.removeEventListener("gattserverdisconnected", onDrop);
    d.addEventListener("gattserverdisconnected", onDrop);
    ch = await findChar(await d.gatt.connect());
    localStorage.setItem(`${key}_name`, d.name || "");
    localStorage.setItem(`${key}_id`, d.id || "");
    emit();
  }

  async function reconnect() {
    if (ch && device?.gatt?.connected) return true;
    try {
      if (device) { await attach(device); return true; }
      if (!navigator.bluetooth?.getDevices) return false;
      const id = localStorage.getItem(`${key}_id`);
      const name = localStorage.getItem(`${key}_name`);
      if (!id && !name) return false;
      const list = await navigator.bluetooth.getDevices();
      const d = list.find((x) => id && x.id === id) || (!id && list.find((x) => x.name === name));
      if (!d) return false;
      await attach(d);
      return true;
    } catch (e) { ch = null; emit(); return false; }
  }

  return {
    status,
    on: (f) => { listeners.add(f); return () => listeners.delete(f); },
    reconnect,
    async connect() {
      if (!bleSupported()) throw new Error("Pelayar ini tidak menyokong Bluetooth. Guna Google Chrome di Android.");
      await attach(await navigator.bluetooth.requestDevice({ acceptAllDevices: true, optionalServices: SERVICES }));
      return status();
    },
    disconnect() {
      try { device?.gatt?.disconnect(); } catch (e) { /* abaikan */ }
      device = null; ch = null;
      localStorage.removeItem(`${key}_name`); localStorage.removeItem(`${key}_id`); emit();
    },
    async write(bytes) {
      if (!(await reconnect())) return false;
      try {
        for (let i = 0; i < bytes.length; i += 100) {
          const part = bytes.slice(i, i + 100);
          if (ch.properties.writeWithoutResponse) await ch.writeValueWithoutResponse(part);
          else await ch.writeValue(part);
          await new Promise((r) => setTimeout(r, 20));
        }
        return true;
      } catch (e) { ch = null; emit(); return false; }
    },
  };
}

export const mainBle = createBle("alfaz_ble");
export const kitchenBle = createBle("alfaz_ble_kitchen");

export const bleStatus = mainBle.status;
export const onBle = mainBle.on;
export const bleConnect = mainBle.connect;
export const bleReconnect = mainBle.reconnect;
export const bleDisconnect = mainBle.disconnect;
export const bleWrite = mainBle.write;
